import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import "datatables.net";
import "datatables.net-responsive";
import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { getAuthCookie } from "../../utils/authCookies";
import { useModuleActionPermissions } from "hooks/useModuleActionPermissions";
import { MODULE_PERMISSION_NAMES } from "utils/moduleActionPermissions";

type Attribute = {
  id: string;
  name: string;
  values: string[];
  description: string;
  status: string;
};

const TeammemberAttributes = () => {
  const [attributes, setAttributes] = useState<Attribute[]>([]);
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState<string | null>(null); // Track deletion in progress
  const token = getAuthCookie("sessionToken");
  const [toastShown, setToastShown] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { canCreate, canView, canEdit, canDelete } = useModuleActionPermissions(
    MODULE_PERMISSION_NAMES.attributes
  );

  useEffect(() => {
    const fetchAttributes = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/product-attributes`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        setAttributes(data);
      } catch (err) {
        setError(
          err instanceof Error ? err.message : "An unknown error occurred"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchAttributes();
  }, [token]);

  // if (attributes?.length === 0) {
  //   return <div>Loading...</div>;
  // }

  useEffect(() => {
    if(attributes!=null && attributes?.length > 0) {
      const table = $("#transactions").DataTable({
        responsive: false,
        destroy: true,
        lengthChange: false,
        ordering: false,
      });

      return () => {
        table.destroy();
      };
    }
  }, [attributes]);

  const handleDelete = async (attributeId: string) => {

    setDeleting(attributeId); // Set the license being deleted

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/product-attributes/${attributeId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete the attribute.");
      }

      toast.success("Attribute deleted successfully!");
      // Update the state by removing the deleted license
      setAttributes((prev) =>
        prev.filter((group) => group.id !== attributeId)
      );
      setDeleting(null); // Clear the deleting state
      navigate(0);
    } catch (err) {
      toast.error("Failed to delete the attribute.");
      setError(
        err instanceof Error
          ? err.message
          : "An unknown error occurred while deleting."
      );
      setDeleting(null); // Clear the deleting state
    }
  };

//   if (loading) {
//     return <div>Loading...</div>;
//   }

  return (
    <div className="content">
      <div className="card">
        <div className="card-body">
          <h2>Attributes </h2>
          <div className="text-end">
            {canCreate && (
              <Link
                to="/teammember/addAttribute"
                className="btn btn-primary float-right"
              >
                Add Attribute
              </Link>
            )}
          </div>
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-12 col-xl-12">
              <div className="card mt-4 card-bg-fill">
                <div className="card-body p-4">
                  <div className="table-container">
                    <table
                      id="transactions"
                      className="table table-bordered dt-responsive nowrap table-striped align-middle w-100"
                    >
                      <thead>
                        <tr>
                          <th>S.No.</th>                          
                          <th>Name</th>
                          <th>Values</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {attributes != null &&
                          attributes?.map((attribute, index) => (
                            <tr key={index}>                              
                              <td>{index + 1}</td>   
                              <td>{attribute.name}</td>
                              <td>{attribute.values.join(",")}</td>
                              <td>
                                {attribute.status ? "Active" : "Inactive"}
                              </td>
                              <td>
                                {(!canView && !canEdit && !canDelete) ? null : (
                                  <>
                                    {canEdit && (
                                      <Link
                                        to={`/teammember/editAttribute/${attribute.id}`}
                                        className="btn btn-warning waves-effect waves-light me-2"
                                      >
                                        <i className="ri-pencil-fill align-bottom me-2"></i>{" "}
                                      </Link>
                                    )}

                                    {canDelete && (
                                      <button
                                        onClick={() =>
                                          window.confirm(
                                            "Are you sure you want to delete this attribute?"
                                          ) && handleDelete(attribute.id)
                                        }
                                        className="btn btn-danger waves-effect waves-light"
                                      >
                                        <i className="ri-delete-bin-fill align-bottom me-2"></i>
                                      </button>
                                    )}
                                  </>
                                )}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeammemberAttributes;
